export const NEW_ITEM = "NEW_ITEM";

export const createEmptyCategoryType = (createdBy) => ({
  createdBy,
  id: `${NEW_ITEM}-${Date.now()}`,
  isNew: true,
  lastUpdated: new Date().toISOString(),
  typeName: "",
  updatedBy: createdBy,
});
